import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Collapse, Slider, Stack } from '@mui/material';
import { FormikProps } from 'formik';
import { VerticalScrolledPanel } from '@ai/common/src/components/VerticalScrolledPanel';
import FormFieldWrapper from '@ai/common/src/sections/expert-configuration/FormFieldWrapper';
import { ExpertDefaults } from '@ai/common/src/types/expert';
import PronunciationSettings from './PronunciationSettings';
import { SoundTest } from './SoundTest';
import { VoiceAndCharacterSettings } from './VoiceAndCharacterSettings';
import { ExpertForm } from '@ai/common/src/types/expert';
import { getUserStore } from '@ai/common/src/store/UserStore';

export enum VoiceGroup {
  YANDEX = 'yandexVoices',
  GOOGLE = 'googleVoices',
  ELEVENLABS = 'elevenlabsVoices',
}

const SpeechTab = observer(
  ({
    expertConstants,
    form,
  }: {
    expertConstants: ExpertDefaults;
    form: FormikProps<ExpertForm>;
  }) => {
    const { t } = useTranslation();
    const { values, setFieldValue } = form;
    const { isAdvancedMode } = getUserStore('platform');

    return (
      <VerticalScrolledPanel spacing={2} pr={2}>
        <VoiceAndCharacterSettings expertConstants={expertConstants} form={form} />

        <FormFieldWrapper
          title={t('expertFormLabels.config.speed')}
          description={t('expertsList.speedDescr')}
          fieldComponent={
            <Stack px={2} pt={1}>
              <Slider
                min={1}
                max={2}
                step={0.1}
                value={values.config.speed}
                onChange={(_, value) => setFieldValue('config.speed', value)}
                valueLabelDisplay="on"
              />
            </Stack>
          }
        />

        <Collapse in={isAdvancedMode} unmountOnExit>
          <FormFieldWrapper
            title={t('expertFormLabels.config.stt_pause_between_words')}
            description={t('expertsList.pausesBetweenWordsDescr')}
            fieldComponent={
              <Stack px={2} pt={1}>
                <Slider
                  min={500}
                  max={3000}
                  step={100}
                  valueLabelDisplay="on"
                  value={values.config.stt_pause_between_words}
                  onChange={(_, value) => setFieldValue('config.stt_pause_between_words', value)}
                />
              </Stack>
            }
          />
        </Collapse>

        <PronunciationSettings form={form} />

        <SoundTest form={form} />
      </VerticalScrolledPanel>
    );
  },
);

export default SpeechTab;
